import { fromEvent } from "rxjs";
import { AddressComponent } from "../addressComponent";
import { hide, show } from "../../../utils";
import { TextboxComponent } from "../textboxComponent";
import { Form } from "../../../components/form";
import { IAddressLookupService, IMessagingService } from "../../../services";
import { SessionDto, AddressDto} from "../../../platform/models";

class EditView {

    private companyNameComponent: TextboxComponent;
    private addressLine1Component: TextboxComponent;
    private addressLine2Component: TextboxComponent;
    private addressLine3Component: TextboxComponent;
    private cityComponent: TextboxComponent;
    private postcodeComponent: TextboxComponent;

    private searchButtonEl: HTMLElement;

    constructor(private viewEl: HTMLElement,  private messagingService: IMessagingService, private form: Form, private component: AddressComponent, private session: SessionDto, private addressLookupService: IAddressLookupService) {

        const companyNameEl = viewEl.querySelector<HTMLInputElement>(".js-companyName");
        this.companyNameComponent = new TextboxComponent(companyNameEl, messagingService, form);

        const addressLine1El = viewEl.querySelector<HTMLInputElement>(".js-addressLine1");
        this.addressLine1Component = new TextboxComponent(addressLine1El, messagingService, form);

        const addressLine2El = viewEl.querySelector<HTMLInputElement>(".js-addressLine2");
        this.addressLine2Component = new TextboxComponent(addressLine2El, messagingService, form);

        const addressLine3El = viewEl.querySelector<HTMLInputElement>(".js-addressLine3");
        this.addressLine3Component = new TextboxComponent(addressLine3El, messagingService, form);

        const cityEl = viewEl.querySelector<HTMLInputElement>(".js-city");
        this.cityComponent = new TextboxComponent(cityEl, messagingService, form);

        const postcodeEl = viewEl.querySelector<HTMLInputElement>(".js-postcode");
        this.postcodeComponent = new TextboxComponent(postcodeEl, messagingService, form);

        this.searchButtonEl = viewEl.querySelector<HTMLElement>(".js-search");

        const components = [
            this.companyNameComponent,
            this.addressLine1Component,
            this.addressLine2Component,
            this.addressLine3Component,
            this.cityComponent,
            this.postcodeComponent
        ];

        components.forEach(component => {
            // rebuild the address value whenever a field value changes. not the most
            // optimal way but says cuts out down on some of the code to set individual changes
            component.onValueChanged$().subscribe(_ => {
                const address = new AddressDto();
                address.companyName = this.companyNameComponent.getValue().value;
                address.addressLine1 = this.addressLine1Component.getValue().value;
                address.addressLine2 = this.addressLine2Component.getValue().value;
                address.addressLine3 = this.addressLine3Component.getValue().value;
                address.city = this.cityComponent.getValue().value;
                address.postcode = this.postcodeComponent.getValue().value;
                this.component.setValue(address);
            });
        })

 
        this.searchButtonEl.addEventListener("click", (e) => {
            e.preventDefault();
            this.component.resetSearch();
        });
    }

    public async editAddress(address: AddressDto) {

        this.companyNameComponent.setValue(address.companyName);
        this.addressLine1Component.setValue(address.addressLine1);
        this.addressLine2Component.setValue(address.addressLine2);
        this.addressLine3Component.setValue(address.addressLine3);
        this.cityComponent.setValue(address.city);
        this.postcodeComponent.setValue(address.postcode);
        
        this.show();
        this.companyNameComponent.setFocus();
    }

    public show() {
        show(this.viewEl);
    }

    public hide() {
        hide(this.viewEl);
    }
}


export { EditView }